import React from 'react';
import { List, LayoutGrid } from 'lucide-react';

import { cn } from '../../lib/utils';

// ================================================================= //
//          ViewToggle Component                                       //
// ================================================================= //

interface ViewToggleProps {
  view: 'list' | 'cards';
  onChange: (view: 'list' | 'cards') => void;
}

/**
 * Simple two-option toggle for switching between list and card views.
 * Selected button gets primary styling, unselected gets secondary.
 */
export const ViewToggle: React.FC<ViewToggleProps> = ({ view, onChange }) => {
  const baseClass = 'inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md transition-colors';
  const activeClass = 'bg-gray-900 text-white';
  const inactiveClass = 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50';

  return (
    <div className="inline-flex gap-1">
      <button
        onClick={() => onChange('list')}
        className={cn(baseClass, view === 'list' ? activeClass : inactiveClass)}
        title="List view"
      >
        <List className="h-4 w-4" />
        <span className="hidden sm:inline">List</span>
      </button>
      <button
        onClick={() => onChange('cards')}
        className={cn(baseClass, view === 'cards' ? activeClass : inactiveClass)}
        title="Card view"
      >
        <LayoutGrid className="h-4 w-4" />
        <span className="hidden sm:inline">Cards</span>
      </button>
    </div>
  );
};
